import { createSlice } from "@reduxjs/toolkit";

const initialState = {
   // actionTrigger: false,
   startDate: null,
   endDate: null,
   locationFilterData: [],
   organizationFilterData: [],
   accountFilterData: [],
   productFilterData: [],
   orderFilterData: [],
   controlIdFilterData: [],
   customerFilterData: [],
   eventFilterData: [],
   userFilterData: [],
   productCategoryFilterData: [],
   productTypeFilterData: [],
   typesFilterData: [],
   productStateFilterData: [],
};

export const SidebarFilterSlice = createSlice({
   name: "sidebarFilter",
   initialState: initialState,
   reducers: {
      // setActionTrigger: (state, action) => {
      //    state.actionTrigger = action.payload;
      // },
      setTimeRange: (state, action) => {
         state.startDate = action.payload.startDate;
         state.endDate = action.payload.endDate;
      },
      setLocationFilterData: (state, action) => {
         state.locationFilterData = action.payload;
      },
      setOrganizationFilterData: (state, action) => {
         state.organizationFilterData = action.payload;
      },
      setAccountFilterData: (state, action) => {
         state.accountFilterData = action.payload;
      },
      setProductFilterData: (state, action) => {
         state.productFilterData = action.payload;
      },
      setOrderFilterData: (state, action) => {
         state.orderFilterData = action.payload;
      },
      setControlIdFilterData: (state, action) => {
         state.controlIdFilterData = action.payload;
      },
      setCustomerFilterData: (state, action) => {
         state.customerFilterData = action.payload;
      },
      setEventFilterData: (state, action) => {
         state.eventFilterData = action.payload;
      },
      setUserFilterData: (state, action) => {
         state.userFilterData = action.payload;
      },
      setProductCategoryFilterData: (state, action) => {
         state.productCategoryFilterData = action.payload;
      },
      setProductTypeFilterData: (state, action) => {
         state.productTypeFilterData = action.payload;
      },
      setTypesFilterData: (state, action) => {
         state.typesFilterData = action.payload;
      },
      setProductStateFilterData: (state, action) => {
         state.productStateFilterData = action.payload;
      },
      resetSidebarFilter: () => initialState,
   },
});
